/**
 * Vendor-detail stat strip — mirrors `prototype/purchases/vendor-detail.html`.
 *
 * @see prototype/purchases/vendor-detail.html `.stat-strip`
 */
import { Banknote, Clock3, ShieldCheck, TrendingUp, type LucideIcon } from "lucide-react";
import { StatTile, type StatTileTone } from "../../master-list/index.ts";

export interface VendorDetailMetric {
  value: string;
  meta: string;
  placeholder?: boolean;
}

export interface VendorDetailMetrics {
  owe: VendorDetailMetric;
  ytdSpend: VendorDetailMetric;
  avgPayment: VendorDetailMetric;
  reliability: VendorDetailMetric;
}

export interface VendorDetailStatStripProps {
  metrics: VendorDetailMetrics;
}

export function VendorDetailStatStrip({ metrics }: VendorDetailStatStripProps) {
  return (
    <section
      className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4"
      aria-label="Vendor stats"
    >
      <Tile label="We owe" icon={Clock3} tone="warn" metric={metrics.owe} />
      <Tile label="YTD spend" icon={Banknote} tone="sky" metric={metrics.ytdSpend} />
      <Tile label="Avg payment" icon={TrendingUp} tone="ok" metric={metrics.avgPayment} />
      <Tile label="Reliability" icon={ShieldCheck} tone="ok" metric={metrics.reliability} />
    </section>
  );
}

function Tile({
  label,
  icon,
  tone,
  metric,
}: {
  label: string;
  icon: LucideIcon;
  tone: StatTileTone;
  metric: VendorDetailMetric;
}) {
  return (
    <StatTile
      label={label}
      value={metric.value}
      meta={metric.meta}
      tone={tone}
      icon={icon}
      placeholder={metric.placeholder}
    />
  );
}
